export default "__VITE_ASSET__CM43l69r__"